<template>
    <div>
        <div class="wrap">
            <div class="tabs">
                <div v-for="tab in tabs" :key="tab._id">
                    <div class="tab-item" :class="[
                        { active: selectTab._id === tab._id },
                        { checked: tab.checked }
                    ]" @click="onChangeTab(tab)">
                        {{ tab.name }}
                    </div>
                </div>
            </div>
            <div class="tab-pane" v-show="selectTab">
                <el-tag v-for="item in selectTab.child" :key="item.id" size="small" class="tag"
                    :type="item.checked ? '' : 'info'" @click="onSelectTag(item)">{{ item.name }}</el-tag>
            </div>
        </div>
    </div>



</template>
<script>
import { getLiveTypeList } from "@/api/material";

export default {
    data() {
        return {
            tabs: [],
            selectTab: {},
        }
    },
    created() {
        this.getList();
    },
    watch: {
        tabs: {
            handler(newVal) {
                console.log('=== watch tabs 触发 ===');
                console.log('newVal 长度:', newVal.length);
                newVal.forEach((tab, tabIndex) => {
                    if (tab.child && tab.child.length) {
                        const allchecked = tab.child.some(child => child.checked);
                        console.log(`  Tab ${tabIndex}: ${tab.name}, allchecked: ${allchecked}`);
                        if (allchecked) {
                            tab.checked = true;
                        }else{
                            tab.checked = false;
                        }
                    }
                });
            },
            deep: true,
        }
    },
    methods: {
        onChangeTab(tab) {
            console.log('=== onChangeTab 被调用 ===');
            console.log('点击的分类:', { _id: tab._id, name: tab.name, hasChild: !!tab.child?.length, oldChecked: tab.checked });
            
            // 如果该分类没有子分类，点击时直接切换选中状态（代表选择"全部"）
            if (!tab.child || tab.child.length === 0) {
                tab.checked = !tab.checked;
                console.log('无子分类，直接切换 checked 状态为:', tab.checked);
            } else {
                // 有子分类时，只切换选中状态用于显示
                tab.checked = !tab.checked;
                console.log('有子分类，切换 checked 状态为:', tab.checked);
            }
            
            // 切换当前选中的 tab
            this.selectTab = tab;
            console.log('当前选中的 tab:', this.selectTab.name);
        },
        onSelectTag(tab) {
            console.log('=== onSelectTag 被调用 ===');
            console.log('被点击的子分类:', { id: tab.id, name: tab.name, parentId: tab.parentId, oldChecked: tab.checked });
            
            tab.checked = !tab.checked;
            console.log('子分类 checked 状态变为:', tab.checked);
            
            // 找到该子分类所属的父级 tab 并更新其 checked 状态
            const parentTab = this.tabs.find(item => item._id === tab.parentId);
            console.log('父级 tab:', parentTab ? { _id: parentTab._id, name: parentTab.name, oldChecked: parentTab.checked } : '未找到');
            
            if (parentTab) {
                if (tab.checked) {
                    // 如果有子分类被选中，父级 tab 也标记为选中
                    this.$set(parentTab, 'checked', true);
                    console.log('父级 tab checked 设置为: true');
                } else {
                    // 检查父级 tab 是否还有其他选中的子分类
                    const hasCheckedChild = parentTab.child && parentTab.child.some(child => child.checked);
                    this.$set(parentTab, 'checked', hasCheckedChild);
                    console.log('父级 tab checked 设置为:', hasCheckedChild);
                }
            }
            
            // 打印当前所有 tabs 的选中状态
            console.log('当前所有 tabs 状态:');
            this.tabs.forEach((t, i) => {
                console.log(`  Tab ${i}: ${t.name}, checked: ${t.checked}, child:`, t.child?.map(c => ({ name: c.name, checked: c.checked })));
            });
        },
        async getList() {
            this.loading = true;
            const { status, data, message } = await getLiveTypeList({
                page: 1,
                pageSize: 100,
            });
            if (status == 10000) {
                this.tabs = data.categories.map((item) => {
                    let result = {
                        checked: false,
                        ...item
                    };
                    if (item.child && item.child.length) {
                        result.child = item.child.map(childItem => ({
                            checked: false,
                            ...childItem
                        }));
                    }
                    return result;
                });
            } else {
                this.$message.error(message);
            }
            this.loading = false;
        },
        getCheckedList(){
            return this.tabs.filter(tab => tab.checked).map(tab => 
                {
                    // 如果有子分类，过滤出选中的子分类
                    if (tab.child && tab.child.length) {
                        tab.child = tab.child.filter(child => child.checked);
                    }
                    // 如果没有子分类，保留空的 child 数组
                    return tab
                }
            );
        }
    }
}
</script>
<style lang="scss" scoped>
.tabs {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    overflow-x: auto;

    .tab-item {
        // display: inline-block;
        margin-bottom: 20px;
        padding: 4px 10px;
        white-space: nowrap;

        &.active {
            color: #333333;
            font-weight: 600;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -12px;
                left: 50%;
                transform: translateX(-50%);
                width: 24px;
                height: 2px;
                border-radius: 1px;
                background-color: #1472ff;
            }
        }
        &.checked {
            color: #1472ff;
        }
    }

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
        height: 6px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #ddd;
    }

    &::-webkit-scrollbar-track {
        background-color: #f5f5f5;
    }
}

.tab-pane {
    height: 120px;

    .tag {
        cursor: pointer;
        transition: none;
        &+.tag {
            margin-left: 10px;
        }
    }
}
</style>